import { all, takeEvery } from 'redux-saga/effects';
import { standardRequest } from 'utils';
import {
  SITES_FETCH,
  SITE_CREATE,
  SITE_UPDATE,
  JOBS_FETCH,
  JOB_FETCH_BY_ID,
  JOB_CREATE,
  JOB_UPDATE,
  TREES_FETCH,
  TREE_FETCH_BY_ID,
  TREE_CREATE,
  TREE_UPDATE,
  TREES_ASSIGN_JOB,
  GROUPS_FETCH,
  GROUP_CREATE,
  GROUP_ADD_TREES,
  GROUP_REMOVE_TREES,
  GROUP_DELETE,
  LOOKUP_ENUMS_FETCH,
  LOOKUP_SPECIES_FETCH,
} from './actions';

function* sitesSaga() {
  yield takeEvery(SITES_FETCH.REQUEST, standardRequest({
    action: SITES_FETCH,
    requestOptions: { method: 'get', url: '/sites' },
  }));
  yield takeEvery(SITE_CREATE.REQUEST, standardRequest({
    action: SITE_CREATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: '/sites',
      data: payload,
    }),
  }));
  yield takeEvery(SITE_UPDATE.REQUEST, standardRequest({
    action: SITE_UPDATE,
    requestOptionsFromPayload: (payload) => {
      const { site_id, ...data } = payload;
      return {
        method: 'put',
        url: `/sites/${site_id}`,
        data,
      };
    },
  }));
}

function* jobsSaga() {
  yield takeEvery(JOBS_FETCH.REQUEST, standardRequest({
    action: JOBS_FETCH,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: '/jobs',
      params: payload,
    }),
  }));
  yield takeEvery(JOB_FETCH_BY_ID.REQUEST, standardRequest({
    action: JOB_FETCH_BY_ID,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: `/jobs/${payload.job_id}`,
    }),
  }));
  yield takeEvery(JOB_CREATE.REQUEST, standardRequest({
    action: JOB_CREATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: '/jobs',
      data: payload,
    }),
  }));
  yield takeEvery(JOB_UPDATE.REQUEST, standardRequest({
    action: JOB_UPDATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'put',
      url: `/jobs/${payload.job_id}`,
      data: payload,
    }),
  }));
}

function* treesSaga() {
  yield takeEvery(TREES_FETCH.REQUEST, standardRequest({
    action: TREES_FETCH,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: '/trees',
      params: payload,
    }),
  }));
  yield takeEvery(TREE_FETCH_BY_ID.REQUEST, standardRequest({
    action: TREE_FETCH_BY_ID,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: `/trees/${payload.tree_id}`,
    }),
  }));
  yield takeEvery(TREE_CREATE.REQUEST, standardRequest({
    action: TREE_CREATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: '/trees',
      data: payload,
    }),
  }));
  yield takeEvery(TREE_UPDATE.REQUEST, standardRequest({
    action: TREE_UPDATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'put',
      url: `/trees/${payload.tree_id}`,
      data: payload,
    }),
  }));
  yield takeEvery(TREES_ASSIGN_JOB.REQUEST, standardRequest({
    action: TREES_ASSIGN_JOB,
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: '/trees/assign',
      data: payload,
    }),
  }));
}

function* groupsSaga() {
  yield takeEvery(GROUPS_FETCH.REQUEST, standardRequest({
    action: GROUPS_FETCH,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: '/groups',
      params: payload,
    }),
  }));
  yield takeEvery(GROUP_CREATE.REQUEST, standardRequest({
    action: GROUP_CREATE,
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: '/groups',
      data: payload,
    }),
  }));
  yield takeEvery(GROUP_ADD_TREES.REQUEST, standardRequest({
    action: GROUP_ADD_TREES,
    requestOptionsFromPayload: (payload) => ({
      method: 'patch',
      url: `/groups/${payload.group_id}/trees`,
      data: { tree_ids: payload.tree_ids },
    }),
  }));
  yield takeEvery(GROUP_REMOVE_TREES.REQUEST, standardRequest({
    action: GROUP_REMOVE_TREES,
    requestOptionsFromPayload: (payload) => ({
      method: 'patch',
      url: `/groups/${payload.group_id}/trees`,
      data: { remove_tree_ids: payload.tree_ids },
    }),
  }));
  yield takeEvery(GROUP_DELETE.REQUEST, standardRequest({
    action: GROUP_DELETE,
    requestOptionsFromPayload: (payload) => ({
      method: 'delete',
      url: `/groups/${payload.group_id}`,
    }),
  }));
}

function* lookupSaga() {
  yield takeEvery(LOOKUP_ENUMS_FETCH.REQUEST, standardRequest({
    action: LOOKUP_ENUMS_FETCH,
    requestOptions: { method: 'get', url: '/lookup/enums' },
  }));
  yield takeEvery(LOOKUP_SPECIES_FETCH.REQUEST, standardRequest({
    action: LOOKUP_SPECIES_FETCH,
    requestOptionsFromPayload: (payload) => ({
      method: 'get',
      url: '/lookup/species',
      params: payload,
    }),
  }));
}

export default function* rootSaga() {
  yield all([
    sitesSaga(),
    jobsSaga(),
    treesSaga(),
    groupsSaga(),
    lookupSaga(),
  ]);
}
